import { useContext, useMemo } from 'react';
import {
    ActionDependant,
    evaluateTemplateValue,
    evaluateTemplateValueCollection,
    GlobalDataContext,
    TemplateContext,
} from '@ea-lab/reactive-json';
import { Briefcase } from 'lucide-react';
import { toList } from '../../../utils/collections';

export const DocProjectBadge = ({ props }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);

    const projectId = evaluateTemplateValue({
        valueToEvaluate: props.projectId,
        templateContext,
        globalDataContext,
    });

    const rawProjects = evaluateTemplateValueCollection({
        valueToEvaluate: props.projects,
        templateContext,
        globalDataContext,
    });

    // `toList` : sous un `DataFilter`, la collection arrive en objet indexé —
    // sans quoi `projects.find` casserait le rendu de tout l'écran.
    const projects = toList(rawProjects);

    const project = useMemo(() => {
        if (!projectId) return null;
        const pid = parseInt(projectId, 10);
        return projects.find((p) => {
            const d = p.data ?? p;
            return parseInt(d.id, 10) === pid;
        }) || null;
    }, [projectId, projects]);

    if (!project) return null;

    const pData = project.data ?? project;

    return (
        <ActionDependant {...props}>
            <a
                href={`/kanban2?id=${pData.id}`}
                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-iris-50 text-iris-700 hover:bg-iris-100 transition-colors border border-iris-200"
            >
                <Briefcase size={12} />
                {pData.name || `Projet #${pData.id}`}
            </a>
        </ActionDependant>
    );
};
